import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "overflow-y-auto-md overflow-y-auto-sm mb-5" }
const _hoisted_2 = { class: "container table-width" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row text-white fs-14 lh-20 pt-2 table-header text-center\"><div class=\"col\">都市計畫名稱</div><div class=\"col\">工業區編號</div><div class=\"col\"><div>工業區總面積(㎡)</div><div>(A)</div></div><div class=\"col\"><div>管制面積(㎡)</div><div>(B)</div></div><div class=\"col\"><div>可申請面積(㎡)</div><div>(C)=B-D</div></div><div class=\"col-3\"><div class=\"row\"><div class=\"col border-bottom\">累計登錄面積(D)</div><div class=\"d-flex pt-1\"><div class=\"col\">面積(㎡)</div><div class=\"col\">百分比</div></div></div></div></div>", 1)
const _hoisted_4 = { class: "col py-3" }
const _hoisted_5 = { class: "col py-3" }
const _hoisted_6 = { class: "col py-3" }
const _hoisted_7 = { class: "col py-3" }
const _hoisted_8 = { class: "col py-3" }
const _hoisted_9 = { class: "col-3 py-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["row text-elite-blue fs-14 lh-20 text-center", { 'bg-gray': index % 2 != 0 }]),
          key: item.totalArea
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.project), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.industrial_district), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.total_area), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.control_area), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(item.licensable_area), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.registered_area), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.registered_rate), 1)
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}